import { SxProps, Theme } from '@mui/material';

/**
 * v2 `NleTimeline` shell recipe adapted for v1 focus tracks: one bordered panel
 * so Live Topics + Personas read as a single timeline stack.
 */
export const focusTracksContainerSx: SxProps<Theme> = {
  my: 1,
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  borderTop: 1,
  borderBottom: 1,
  borderColor: 'divider',
  overflow: 'hidden',
  bgcolor: 'background.paper',
  cursor: 'pointer',
};
